(function () {
	'use strict';

	a3_cabin_reports.factory('CabinReportLocalEditFactory', CabinReportLocalEditFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CabinReportLocalEditFactory
    * @description 
    *   Manage Local Cabin Reports.
    * @ngInject
    */
	function CabinReportLocalEditFactory($log, localStorageMD5Service, CCMSFactory, LogService, UserFactory, GenericService, GroundServicesFactory,BarTrolleyFactory, enableWaterUpliftReporting, waterUpliftSupportingAcTypes) {

        /**
         * Initialiaze CabinReportLocalEdit object 
         * @memberof CabinReportLocalEditFactory
         */
		function CabinReportLocalEdit() {
			this.ReportGuid = null;
			this.AuthorId = null;
			this.AuthorAimsId = null;
			this.AuthorName = null;
			this.Created = null;
			this.FlightAimsId = null;
			this.FlightId = null;
			this.LastUpdated = null;
			this.Departure = null;
			this.Arrival = null;
			this.AcType = null;
			this.AcTailNo = null;
			this.FlightDate = null;
			this.FlightNo = null;
			//v1.1 added pax and dep/arr details
			this.BookedC = null;
			this.BookedY = null;
			this.BookedInf = null;
			this.BookedPad = null;
			this.BookedChld = null;
			this.ActualC = null;
			this.ActualY = null;
			this.ActualInf = null;
			this.ActualPad = null;
			this.ActualChld = null;
			this.DepartureICAO = null;
			this.DepartureCountry = null;
			this.DepartureName = null;
			this.ArrivalICAO = null;
			this.ArrivalCountry = null;
			this.ArrivalName = null;
			this.ScheduledDeparture = null;
			this.ScheduledDepartureDateUTC = null;
			this.ScheduledDepartureTimeUTC = null;
			this.Departure = null;
			this.Arrival = null;
			this.ReportId = null;
			this.Status = null; // pending, draft, completed, synched
			this.IsValid = false;

			//new fields
			this.DepartureGate = null;
			this.DepartureTimezone = null;
			this.ArrivalTimezone = null;
			this.CallSign = null;
			this.ScheduledArrival = null;
			this.ActiveVariousIssues = 0;
			this.WarningVariousIssues = 0;
			this.CCMSCrewPositions = [];
			this.CCMSCrewPositionsIsValid = false;
			this.CCMSCrewPositionsErrorMessage = null;
			this.FlightReportSubmittedBy1L = true;
			this.CrewRemarks = null;
			this.ItemsFoundDescription = null;
			this.ItemsFoundAgent = null;
			this.ItemsFoundSignature = null;
			this.ItemsFoundSectionHasValue = false;
			this.ItemsFoundSectionIsValid = false;
			this.UMNumber = 0;
			this.UMDescription = null;
			this.UMAgent = null;
			this.UMSignature = null;
			this.UMSectionHasValue = false;
			this.UMSectionIsValid = false;
			this.WaterUpliftSuggestedQuantity = null;
			this.WaterUpliftInitial = null;
			this.WaterUpliftRemarks = null;
			this.WaterSectionHasValue = false;
			this.WaterSectionIsValid = false;
			this.GroundServicesSectionHasValue = false;
			this.BarTrolleys = [];
			this.BarTrolleysIsValid = false;
			this.FirstAidKits = [];
			this.FirstAidKitsIsValid = [];
			this.MedicalIncidents = [];
			this.MedicalIncidentsIsValid = [];
			this.SpecialMealIssues = [];
			this.SpecialMealIssuesIsValid = false;
			this.Supplies = [];
			this.SuppliesIsValid = false;
			this.SuppliesErrorMessage = null;
			this.TravelValueSeals = [];
			this.TravelValueSealsIsValid = false;
			this.TravelValueIncomplete = false;
			this.TravelValueIncompleteRow = null;
			this.TravelValueIncompleteReason = null;
			this.TravelValueRemarks = null;
			this.Remarks = null;
			this.VariousIssues = [];
			//v1.1 :: used to hold all crew (fd, cabin & dhc)
			this.crew = null;
			this.Route = null;
			this.DutyDate = null;
			this.getDescription = getDescription;
			this.getRoute = getRoute;
			this.updateTotals = updateTotals;
			this.validateCCMS = validateCCMS;
			this.getCCMSObj = getCCMSObj;
			this.saveReport = saveReport;
			this.saveReportAsTemp = saveReportAsTemp;
			this.getRemaining = getRemaining;
			this.ArrivalGroundServices = [];
			this.DepartureGroundServices = [];
			this.UpgradedPassengers = [];
			this.ChangedSeats = [];
			this.IncompleteServices = [];
			this.IncompleteServicesIsValid = false;
			//this.BoardingTimes = null;
			this.BoardingTimesRemarks = null;
			this.FirstPaxTime = null;
			this.LastPaxTime = null;
			this.showBarTrolleyUploadImage = true;
			this.showBarTrolleyInsertData = true;
			this.disableBarTrolleysPhotoRemarks = true;
			this.LuggageNumber = 0;
			this.LuggageDescription = null;
			this.FoundProperties = [];

			this.FlightOrdersSectionHasValue = false;
			this.FlightOrders = [];
			this.FlightOrdersSectionErrorMessage = null;
			this.GetId = GetId;

			this.GroomingReports = [];
		}
		var objType = 'cabinReportLocalEdits';
		var objCallback = CabinReportLocalEdit;

		var service = {
			fromObject: fromObject,
			fromObjectList: fromObjectList,
			getCabinReportsFromStorage: getCabinReportsFromStorage,
			setCabinReportsToStorage: setCabinReportsToStorage,
			deleteTempReport: deleteTempReport,
			getPreviousCabinReportCcmsPositions: getPreviousCabinReportCcmsPositions,
			deleteReport: deleteReport,
			setCabinReportToStorage: setCabinReportToStorage,
			getCabinReportLocalEditFromTemp: getCabinReportLocalEditFromTemp,
			getCabinReportLocalEditForFlight: getCabinReportLocalEditForFlight,
			getCabinReportLocalEdit: getCabinReportLocalEdit,
			getCabinReportLocalEditCountThatNeedToBeSynched: getCabinReportLocalEditCountThatNeedToBeSynched,
			IsExistForRouteDutyDate: IsExistForRouteDutyDate,
			getCabinReportLocalEditThatNeedToBeSynched: getCabinReportLocalEditThatNeedToBeSynched,
			getNewReport: getNewReport,
			markReportAsSynched: markReportAsSynched,
			checkForNewGroundServices: checkForNewGroundServices,
			getFlightIdsWithPendingReports: getFlightIdsWithPendingReports,
			getGroomingReports: getGroomingReports
		}

		function getGroomingReports() {
			var allReports = getCabinReportsFromStorage();
			var groomingReports = [];
		
			allReports.forEach(report => {
				if (report.GroomingReports) {
					report.GroomingReports.forEach(groomingReport => {
						if (!groomingReport.isSynced) {
							groomingReports.push({
								reportGuid: report.ReportGuid,
								crewId: groomingReport.crewId,
								groomingCategoryId: groomingReport.groomingCategoryId,
								feedback: groomingReport.feedback,
								isSynced: groomingReport.isSynced,
							});
						}
					});
				}
			});
		
			return groomingReports;
		}

        /**
         * Overide default get Id
         * @memberof CabinReportLocalEditFactory
         * @returns {string} ReportGuid 
         */
		function GetId() {
			return this.ReportGuid;
		}

        /**
         * Get a short Description of this cabin report
         * @memberof CabinReportLocalEditFactory
         * @returns {string} Description 
         */
		function getDescription() {
			var s = this.FlightNo + ' ' + this.Departure + '-' + this.Arrival + ' ' + this.ScheduledDepartureDateUTC + ' by ' + this.AuthorName;
			return s;
		}

        /**
         * Get the Route of this cabin report
         * @memberof CabinReportLocalEditFactory
         * @returns {string} Route 
         */
		function getRoute() {
			if (this.Departure == null && this.Arrival == null) return '-';
			else return (this.Departure || '?') + '-' + (this.Arrival || '?');
		}

        /**
         * Update the totals of all the section of the report
         * @memberof CabinReportLocalEditFactory
         */
		function updateTotals() {
			// check the various issues
			var allActiveVariousIssues = 0;
			var allWarningVariousIssues = 0;

			var variousItemCount = this.VariousIssues.length;
			for (var i = 0; i < variousItemCount; i++) {

				if (this.VariousIssues[i].ItemHasValue == true) {

					if ((this.VariousIssues[i].ItemValue != null) &&
						(this.VariousIssues[i].ItemValue != '')) {
						allActiveVariousIssues++;
					} else {
						allWarningVariousIssues++;
					}
				}
			}

			this.ActiveVariousIssues = allActiveVariousIssues;
			this.WarningVariousIssues = allWarningVariousIssues;
			// check if the report is valid
			this.IsValid = true;

			// various issues
			if (this.WarningVariousIssues > 0) {
				this.IsValid = false;
			}


			// ccms crew positions
			this.CCMSCrewPositionsIsValid = true;
			for (var i = 0; i < this.CCMSCrewPositions.length; i++) {
				if ((this.CCMSCrewPositions[i].CrewId == null) || (this.CCMSCrewPositions[i].CrewId == '') ||
					/*(this.CCMSCrewPositions[i].Initials == null) || (this.CCMSCrewPositions[i].Initials == '') ||*/ //AIMS has crew with empty 3ltr code
					(this.CCMSCrewPositions[i].Name == null) || (this.CCMSCrewPositions[i].Name == '') ||
					(this.CCMSCrewPositions[i].Position == null) || (this.CCMSCrewPositions[i].Position == '')) {
					this.IsValid = false;
					this.CCMSCrewPositionsIsValid = false;
				}
			}

			if (!this.validateCCMS()) {
				this.IsValid = false;
				this.CCMSCrewPositionsIsValid = false;
			}

			this.FlightReportSubmittedBy1L = false;
			var user = UserFactory.getUser();
			if (user.position == "FA") {
				this.FlightReportSubmittedBy1L = true;
			} else {
				for (var i = 0; i < this.CCMSCrewPositions.length; i++) {
					if (user.aimsId == this.CCMSCrewPositions[i].CrewId && (this.CCMSCrewPositions[i].CCMS == "1L" || this.CCMSCrewPositions[i].CCMS == null || this.CCMSCrewPositions[i].CCMS == "")) {
						this.FlightReportSubmittedBy1L = true;
						break;
					}
				}
			}

			// items found
			this.ItemsFoundSectionIsValid = true;
			this.ItemsFoundSectionHasValue = false;
			if (((this.ItemsFoundDescription != null) && (this.ItemsFoundDescription != '')) ||
				((this.ItemsFoundAgent != null) && (this.ItemsFoundAgent != '')) ||
				((this.ItemsFoundSignature != null) && (this.ItemsFoundSignature != ''))) {
				this.ItemsFoundSectionHasValue = true;

				if (!(((this.ItemsFoundDescription != null) && (this.ItemsFoundDescription != '')) &&
					((this.ItemsFoundAgent != null) && (this.ItemsFoundAgent != '')) &&
					((this.ItemsFoundSignature != null) && (this.ItemsFoundSignature != '')))) {
					this.IsValid = false;
					this.ItemsFoundSectionIsValid = false;
				}
			}

			// unaccompanied minors
			this.UMSectionIsValid = true;
			this.UMSectionHasValue = false;
			this.UMNumber = parseInt(this.UMNumber);
			if (isNaN(this.UMNumber))
				this.UMNumber = 0;

			//UM has a value, if UMNo > 0
			if ((this.UMNumber != null) && (this.UMNumber > 0))
				this.UMSectionHasValue = true;

			//UM is invalid, if it has a value but not all required fields are in place
			if (this.UMSectionHasValue &&
				(
					(this.UMAgent == null || this.UMAgent == '') ||
					(this.UMSignature == null || this.UMSignature == '')
				)
			) {
				this.IsValid = false;
				this.UMSectionIsValid = false;
			}
			
			// luggage 
			this.LuggageSectionIsValid = true;
			this.LuggageSectionHasValue = false;
			this.LuggageNumber = parseInt(this.LuggageNumber);
			if (isNaN(this.LuggageNumber))
				this.LuggageNumber = 0;

			//Luggage has a value, if LuggageNo > 0
			if ((this.LuggageNumber != null) && (this.LuggageNumber > 0))
				this.LuggageSectionHasValue = true;

			var today = new Date(this.FlightDate);
			this.WaterSectionIsValid = true;
			this.WaterSectionHasValue = false;

			if (enableWaterUpliftReporting && 
				(((this.WaterUpliftInitial != null) && (this.WaterUpliftInitial != '')) ||
				((this.WaterUpliftRemarks != null) && (this.WaterUpliftRemarks != '')) || 
				((today.getDate() == 1 || today.getDate() == 15) && waterUpliftSupportingAcTypes.includes(this.AcType)))) {
				this.WaterSectionHasValue = true;

				if (!((this.WaterUpliftInitial != null) && (this.WaterUpliftInitial != ''))) {
					this.IsValid = false;
					this.WaterSectionIsValid = false;
				} else {
					this.WaterSectionIsValid = true;
				}
			}

			this.GroundServicesSectionHasValue = false;
			if (this.ArrivalGroundServices) {
				for (var i = 0; i < this.ArrivalGroundServices.length; i++) {
					if (this.ArrivalGroundServices[i].Used) {
						this.GroundServicesSectionHasValue = true;
					}
				}
			}
			if (this.DepartureGroundServices) {
				for (var i = 0; i < this.DepartureGroundServices.length; i++) {
					if (this.DepartureGroundServices[i].Used) {
						this.GroundServicesSectionHasValue = true;
					}
				}
			}


			this.FlightOrdersSectionHasValue = false;
			this.FlightOrdersSectionErrorMessage = null;

			if( !this.FlightOrders || !this.FlightOrders.Orders || this.FlightOrders.Orders.length == 0  || flightOrdersIsCompleted(this.FlightOrders)){
				this.FlightOrdersSectionHasValue = true;
			}else{
				this.IsValid = false;
				//this.FlightOrdersSectionErrorMessage = "Please complete all orders.";
			}
			

			// bar/trolleys
			this.BarTrolleysIsValid = true;
			for (var i = 0; i < this.BarTrolleys.length; i++) {
				if (((this.BarTrolleys[i].Position == null) || (this.BarTrolleys[i].Position == '')) && this.BarTrolleys[i].Photos.length == 0) {
					BarTrolleyFactory.deleteFromList(this.BarTrolleys[i],this.BarTrolleys);
					//this.IsValid = false;
					//this.BarTrolleysIsValid = false;
				}
			}
			showOrHideBarTrolleyInputs(this);

			// first aid kits
			this.FirstAidKitsIsValid = true;
			for (var i = 0; i < this.FirstAidKits.length; i++) {
				if ((this.FirstAidKits[i].Position == null) || (this.FirstAidKits[i].Position == '')) {
					this.IsValid = false;
					this.FirstAidKitsIsValid = false;
				}
			}

			// medical incidents
			this.MedicalIncidentsIsValid = true;
			for (var i = 0; i < this.MedicalIncidents.length; i++) {
				if ((this.MedicalIncidents[i].Name == null) || (this.MedicalIncidents[i].Name == '') ||
					(this.MedicalIncidents[i].FAKUsed == null) || (this.MedicalIncidents[i].FAKUsed == '') ||
					(this.MedicalIncidents[i].Symptoms == null) || (this.MedicalIncidents[i].Symptoms == '') ||
					(this.MedicalIncidents[i].DoctorInvolved == null) || (this.MedicalIncidents[i].DoctorInvolved == '')) {
					this.IsValid = false;
					this.MedicalIncidentsIsValid = false;
				}
			}

			// special meals issues
			this.SpecialMealIssuesIsValid = true;
			for (var i = 0; i < this.SpecialMealIssues.length; i++) {
				if ((this.SpecialMealIssues[i].Name == null) || (this.SpecialMealIssues[i].Name == '') ||
					(this.SpecialMealIssues[i].Source == null) || (this.SpecialMealIssues[i].Source == '') ||
					(this.SpecialMealIssues[i].MealType == null) || (this.SpecialMealIssues[i].MealType == '')) {
					this.IsValid = false;
					this.SpecialMealIssuesIsValid = false;
				}
			}

			// supplies
			this.SuppliesIsValid = true;
			this.SuppliesErrorMessage = null;
			for (var i = 0; i < this.Supplies.length; i++) {
				if ((this.Supplies[i].SupplyType == null) || (this.Supplies[i].SupplyType == '') || (this.Supplies[i].SupplyType == '-')) {
					this.IsValid = false;
					this.SuppliesIsValid = false;
				}

				for (var j = 0; j < this.Supplies.length; j++) {
					if ((this.Supplies[i].Id != this.Supplies[j].Id) &&
						(this.Supplies[i].SupplyType == this.Supplies[j].SupplyType)) {
						this.IsValid = false;
						this.SuppliesIsValid = false;
						this.SuppliesErrorMessage = "You cannot have the same supply issue more than once.";
					}
				}
			}

			// travel value seals
			this.TravelValueSealsIsValid = true;
			for (var i = 0; i < this.TravelValueSeals.length; i++) {
				if ((this.TravelValueSeals[i].Position == null) || (this.TravelValueSeals[i].Position == '')) {
					this.IsValid = false;
					this.TravelValueSealsIsValid = false;
				}
			}

			// travel value incomplete
			this.TravelValueIncompleteIsValid = true;
			this.TravelValueIncompleteErrorMessage = null;
			if (this.TravelValueIncomplete) {
				// "0" == "" so use === for comparison to empty string
				if (typeof (this.TravelValueIncompleteRow) == "undefined" || this.TravelValueIncompleteRow === "" || this.TravelValueIncompleteRow == null) {
					this.TravelValueIncompleteIsValid = false;
					this.TravelValueIncompleteErrorMessage = "Travel Value Stopped at row is required";
				} else if (typeof (this.TravelValueIncompleteReason) == "undefined" || this.TravelValueIncompleteReason == "" || this.TravelValueIncompleteReason == null) {
					this.TravelValueIncompleteIsValid = false;
					this.TravelValueIncompleteErrorMessage = "Travel Value Incomplete Reason is required";
				}
			}


			// Incomplete Services 
			this.IncompleteServicesIsValid = true;
			for (var i = 0; i < this.IncompleteServices.length; i++) {
				if ((this.IncompleteServices[i].ServiceClass == null) ||
					(this.IncompleteServices[i].FromRowNo == '') ||
					(this.IncompleteServices[i].ToRowNo == '') ||
					(this.IncompleteServices[i].ServiceType == '') ||
					(this.IncompleteServices[i].Reason == '') ||
					(this.IncompleteServices[i].FromRowNo > this.IncompleteServices[i].ToRowNo)) {
					this.IsValid = false;
					this.IncompleteServicesIsValid = false;
				}
			}
		}

        /**
         * Validate the Crew Positions
         * @memberof CabinReportLocalEditFactory
         */
		function validateCCMS() {
			this.CCMSCrewPositionsErrorMessage = null;
			var valuesInError = new Array();
			for (var i = 0; i < this.CCMSCrewPositions.length; i++) {
				if ((this.CCMSCrewPositions[i].CCMS == null) || (this.CCMSCrewPositions[i].CCMS == '')) {
					this.CCMSCrewPositionsErrorMessage = "You must fill CCMS for all crew members";
					return false;
				}
			}

			var allCCMSPositions = CCMSFactory.getCCMSFromStorage();

			// if not multiple then this position must not be found in another
			// place in the array
			var multiplePositionsInError = new Array();
			for (var i = 0; i < this.CCMSCrewPositions.length; i++) {
				var ccmsObj_i = this.getCCMSObj(allCCMSPositions, this.CCMSCrewPositions[i].CCMS);
				if (ccmsObj_i.ccmsPositionsIsValid) {
					var ccms_i = ccmsObj_i.ccms;
					if (ccms_i.Multiple == false) {
						for (var j = 0; j < this.CCMSCrewPositions.length; j++) {
							var ccmsObj_j = this.getCCMSObj(allCCMSPositions, this.CCMSCrewPositions[j].CCMS);
							if (ccmsObj_j.ccmsPositionsIsValid) {
								var ccms_j = ccmsObj_j.ccms;
								if (this.CCMSCrewPositions[i].CrewId != this.CCMSCrewPositions[j].CrewId) {

									if (ccms_i.Position == ccms_j.Position) {

										if (multiplePositionsInError.indexOf(ccms_i.Position) < 0)
											multiplePositionsInError.push(ccms_i.Position);
									}
								}
							}
						}
					}
				} else {
					valuesInError.push(this.CCMSCrewPositions[i].CCMS);
					this.CCMSCrewPositions[i].CCMS = null;
				}
			}

			if (valuesInError.length == 1) {
				this.CCMSCrewPositionsErrorMessage = "You cannot assigned the position " + valuesInError + " in this flight";
			} else if (valuesInError.length > 1) {
				this.CCMSCrewPositionsErrorMessage = "You cannot assigned the positions " + valuesInError + " in this flight";
			}

			if (multiplePositionsInError.length > 0) {

				var multiplePositionError = "";
				for (var i = 0; i < multiplePositionsInError.length; i++) {

					if (multiplePositionError != "") {
						multiplePositionError = multiplePositionError + ", ";
					}
					multiplePositionError = multiplePositionError + multiplePositionsInError[i];
				}

				if (multiplePositionsInError.length == 1)
					this.CCMSCrewPositionsErrorMessage = "You have assigned the position " + multiplePositionError + " multiple times";
				else
					this.CCMSCrewPositionsErrorMessage = "You have assigned the positions " + multiplePositionError + " multiple times";
			}

			if (this.CCMSCrewPositionsErrorMessage != null)
				return false;
			else
				return true;
		}

        /**
         * Get the CCMS Positions of this aircraft
         * @memberof CabinReportLocalEditFactory
         */
		function getCCMSObj(ccms, pos) {
			var AcTypeIsValid = false;
			var ccmsPositionsIsValid = false;
			var ccmsObj = null;
			for (var i = 0; i < ccms.length; i++) {

				// find the positions for this aircraft type
				if (ccms[i].Aircraft == this.AcType) {
					AcTypeIsValid = true;
					for (var j = 0; j < ccms[i].Positions.length; j++) {
						if (ccms[i].Positions[j].Position == pos) {
							ccmsObj = ccms[i].Positions[j];
							ccmsPositionsIsValid = true;
						}
					}
				}
			}
			if (!AcTypeIsValid) {
				var log = "CCMS , POS=" + this.CCMSCrewPositions[j].CCMS + ", Ac=" + this.AcType + ", all=" + JSON.stringify(allCCMSPositions);
				log = log.replace(/"Multiple":/g, "").replace(/"Position":/g, "").replace(/"Aircraft"/g, "AC").replace(/true/g, 1).replace(/false/g, 0).replace(/"/g, "").replace(/Positions/g, "Ps");
				LogService.debug(log);
			}

			return {
				AcTypeIsValid: AcTypeIsValid,
				ccmsPositionsIsValid: ccmsPositionsIsValid,
				ccms: ccmsObj
			}
		}

        /**
         * Save the Cabin Report
         * @memberof CabinReportLocalEditFactory
         */
		function saveReport() {

			// update the LastUpdated field
			this.LastUpdated = new Date();

			// get the reports array from storage
			var allReports = getCabinReportsFromStorage();
			if (allReports == null)
				allReports = new Array();

			// find the current report from the array (if present)
			var arrayLength = allReports.length;
			var reportIndex = -1;
			for (var i = 0; i < arrayLength; i++) {
				if (allReports[i].ReportGuid == this.ReportGuid) {
					reportIndex = i;
					break;
				}
			}

			// add or update a copy of the current report
			if (reportIndex >= 0)
				allReports[reportIndex] = this;
			else
				allReports.push(this);

			// save
			setCabinReportsToStorage(allReports);
		}

        /**
         * Save the Report As Temp
         * @memberof CabinReportLocalEditFactory
         */
		function saveReportAsTemp() {

			// update the LastUpdated field
			this.LastUpdated = new Date();

			// save as temp
			localStorageMD5Service.remove('cabinReportLocalEdit_TEMP');
			localStorageMD5Service.set('cabinReportLocalEdit_TEMP', this);
		}

        /**
         * Get the remaining characters of this field
         * @memberof CabinReportLocalEditFactory
         */
		function getRemaining(max, text) {
			if (typeof (text) === "undefined" || text === null) return '';
			if (typeof (max) === "undefined" || max === null || max < 0 || !max) max = 5000;
			var length = text.length;
			/*var matches = text.match(/\n/g);
			if (matches)
				length += matches.length;*/
			//if(max > length)
			return 'characters left: ' + (max - length);
			//else
			//	return '-full-';
		}

		//Factory functions
        /**
         * Extend Object from the default local Cabin Report Object
         * @memberof CabinReportLocalEditFactory
         * @param {Object} obj  a CabinReportLocalEdit
         * @returns {Object} CabinReportLocalEdit
         */
		function fromObject(obj) {
			return GenericService.fromObject(obj, objCallback);
		}

        /**
         * Extend Object List from the default local Cabin Report Object
         * @memberof CabinReportLocalEditFactory
         * @param {Array} objList  a CabinReportLocalEdit list
         * @returns {Array} CabinReportLocalEdits
         */
		function fromObjectList(objList) {
			return GenericService.fromObjectList(objList, objCallback);
		}

        /**
         * Get Cabin Reports from storage
         * @memberof CabinReportLocalEditFactory
         * @returns {Array} CabinReports
         */
		function getCabinReportsFromStorage() {
			return GenericService.list(objType, objCallback);
		}

        /**
         * Save Cabin Reports to storage
         * @memberof CabinReportLocalEditFactory
         * @param {Array} cabinReportLocalEdits A list of Cabin Reports 
         */
		function setCabinReportsToStorage(cabinReportLocalEdits) {
			GenericService.saveAll(cabinReportLocalEdits, objType, objCallback);
		}

        /**
         * Delete Cabin Temporary Report from storage
         * @memberof CabinReportLocalEditFactory
         */
		function deleteTempReport() {
			localStorageMD5Service.remove('cabinReportLocalEdit_TEMP');
		}

        /**
         * Get the CCMS positions of the previous flight
         * @memberof CabinReportLocalEditFactory
         * @param {string} guid The report GUID
         * @param {string} acNo The Aircaft Number
         * @param {string} flightDateUTC The flight date in UTC
         * @param {string} flightTimeUTC The flight time in UTC
         * @return {Array} CCMSpositions
         */
		function getPreviousCabinReportCcmsPositions(guid, acNo, flightDateUTC, flightTimeUTC) {
			var previousCcms = null;
			try {
				var flightDate = new Date(flightDateUTC + ' ' + flightTimeUTC); //date of ref flight
				var flightDateMatch = null;
				var flightDateCheck = null;
				var previousRep = null;
				var report = null;
				var reports = getCabinReportsFromStorage();
				//console.debug('Find previous report for ' + acNo + ' ' + flightDateUTC + ' ' + flightTimeUTC);
				if (reports != null && reports.length > 0) {
					//loop all reports to find the previous one based on the input data
					var x;
					for (var i = 0; i < reports.length; i++) {
						report = reports[i];
						flightDateCheck = new Date(report.ScheduledDepartureDateUTC + " " + report.ScheduledDepartureTimeUTC);
						//console.debug('	' + report.AcTailNo + ' ' + report.FlightNo + ' ' + report.Departure + '-' + report.Arrival + ' ' + report.ScheduledDepartureDateUTC + " " + report.ScheduledDepartureTimeUTC);

						//flight too old to be "previous"
						if (((flightDate - flightDateCheck) / 1000 / 60 / 60) > 6) {
							x = 0;
							//console.debug('		past flight, not acceptable');
						}
						//same report as ref one
						else if (report.ReportGuid == guid) {
							x = 1;
							//console.debug('		same report');
						}
						//worse match than current one
						else if (flightDateMatch != null && flightDateCheck < flightDate && flightDateMatch < flightDateCheck) {
							x = 2;
							//console.debug('		previous match is a closer one');
						}
						//later than ref flight
						else if (flightDate < flightDateCheck) {
							x = 3;
							//console.debug('		later than ref flight');
						}
						//match!
						else {
							//console.debug('		candidate');
							//store selected report
							previousRep = report;
							flightDateMatch = flightDateCheck;
						}
					}
				}
				if (previousRep != null && previousRep.CCMSCrewPositions != null && previousRep.CCMSCrewPositions.length > 0) {
					previousCcms = previousRep.CCMSCrewPositions;
				}
			} catch (e) {
				console.error(e);
			}
			return previousCcms;
		}

        /**
         * Delete Selected repport
         * @memberof CabinReportLocalEditFactory
         * @param {string} reportGuid The report's Identifier
         */
		function deleteReport(reportGuid) {
			GenericService.remove(reportGuid, objType, objCallback);
		}

        /**
         * Save Selected Cabin repport
         * @memberof CabinReportLocalEditFactory
         * @param {Object} report A Cabin Report
         */
		function setCabinReportToStorage(report) {
			GenericService.save(report, objType, objCallback);
		}

        /**
         * Get Temporary Cabin repport
         * @memberof CabinReportLocalEditFactory
         * @return {Object} report 
         */
		function getCabinReportLocalEditFromTemp() {
			var cabinReportLocalEdit = localStorageMD5Service.get('cabinReportLocalEdit_TEMP');
			cabinReportLocalEdit = checkForNewGroundServices(cabinReportLocalEdit);
			return fromObject(cabinReportLocalEdit);
		}

        /**
         * Get the Cabin repport of this flight
         * @memberof CabinReportLocalEditFactory
         * @param {number} flightId A flight Id
         * @return {Object} report 
         */
		function getCabinReportLocalEditForFlight(flightId) {
			var cabinReportLocalEdits = getCabinReportsFromStorage();
			if (cabinReportLocalEdits == null)
				return null;

			var result = null;

			var arrayLength = cabinReportLocalEdits.length;
			for (var i = 0; i < arrayLength; i++) {
				if (cabinReportLocalEdits[i].FlightId == flightId) {
					result = cabinReportLocalEdits[i];
					break;
				}
			}
			result = checkForNewGroundServices(result);
			return result;
		}

		/**
         * add any new ground services from storage to the existing report
         * @memberof CabinReportLocalEditFactory
		 * @param {Object} report
         * @return {Object} report 
         */
		function checkForNewGroundServices(report) {
			if (report == null)
				return report;

			var depStorageGroundServices = GroundServicesFactory.getGroundServicesByStation(report.Departure);
			//var arrStorageGroundServices =  GroundServicesFactory.getGroundServicesByStation(report.Arrival);
			for (var i = 0; i < depStorageGroundServices.length; i++) {
				var found = false;
				for (var j = 0; j < report.DepartureGroundServices.length; j++) {
					if (depStorageGroundServices[i].ServiceType === report.DepartureGroundServices[j].ServiceType) {
						//this ground service is available according to the localstorage but its not in the report
						found = true;
						break;
					}
				}
				if (!found) {
					report.DepartureGroundServices.push(depStorageGroundServices[i]);
				}
			}
			//Disable arrival ground services from report:
			// for (var i = 0; i < arrStorageGroundServices.length; i++) {
			// 	var found = false;
			// 	for (var j = 0; j < report.ArrivalGroundServices.length; j++){
			// 		if (arrStorageGroundServices[i].ServiceType === report.ArrivalGroundServices[j].ServiceType){
			// 			//this ground service is available according to the localstorage but its not in the report
			// 			found = true;
			// 			break;
			// 		}
			// 	}
			// 	if (!found){
			// 		report.ArrivalGroundServices.push(arrStorageGroundServices[i]);
			// 	}
			//}
			return report;
		}

        /**
         * Get the Cabin repport
         * @memberof CabinReportLocalEditFactory
         * @param {string} reportGuid A report Id
         * @return {Object} report 
         */
		function getCabinReportLocalEdit(reportGuid) {
			var report = GenericService.get(reportGuid, objType, objCallback);
			report = checkForNewGroundServices(report);
			return report;
		}

        /**
         * Get the number of reports that need to be synched
         * @memberof CabinReportLocalEditFactory
         * @return {number} result A Cabin Report
         */
		function getCabinReportLocalEditCountThatNeedToBeSynched() {
			var cabinReportLocalEdits = getCabinReportsFromStorage();
			if (cabinReportLocalEdits == null)
				return 0;

			var result = 0;

			for (var i = 0; i < cabinReportLocalEdits.length; i++) {
				if (cabinReportLocalEdits[i].Status === 'completed') {
					result++;
				}
			}

			return result;
		}

        /**
         * Cabin report Exist For Route and DutyDate
         * @memberof CabinReportLocalEditFactory
         * @param {string} Route The flight's route
         * @param {string} Dutydate The flight's duty date
         * @return {boolean} result
         */
		function IsExistForRouteDutyDate(Route, Dutydate) {
			var cabinReportLocalEdits = getCabinReportsFromStorage();
			if (cabinReportLocalEdits == null)
				return false;

			var result = false;

			for (var i = 0; i < cabinReportLocalEdits.length; i++) {
				if (cabinReportLocalEdits[i].Route == Route && cabinReportLocalEdits[i].Dutydate) {
					result = true;
					break;
				}
			}

			return result;
		}

        /**
         * Get the reports that need to be synched
         * @memberof CabinReportLocalEditFactory
         * @return {array} result 
         */
		function getCabinReportLocalEditThatNeedToBeSynched() {
			var result = [];

			var cabinReportLocalEdits = getCabinReportsFromStorage();
			if (cabinReportLocalEdits == null)
				return result;

			for (var i = 0; i < cabinReportLocalEdits.length; i++) {
				if (cabinReportLocalEdits[i].Status === 'completed') {
					result.push(cabinReportLocalEdits[i]);
				}
			}

			return result;
		}

        /**
         * Gonstructor for a new cabin Report
         * @memberof CabinReportLocalEditFactory
         * @return {array} result 
         */
		function getNewReport() {
			return GenericService.constructor(objCallback);
		}

        /**
         * Mark selected report As Synched
         * @memberof CabinReportLocalEditFactory
         * @param {string} reportGuid The report Guid
         * @return {boolean} isSuccess 
         */
		function markReportAsSynched(reportGuid) {

			var report = getCabinReportLocalEdit(reportGuid);
			if (report == null)
				return false;

			report.Status = 'synched';
			report.saveReport();

			return true;
		}

		function showOrHideBarTrolleyInputs(report) {
			var photos = report.BarTrolleys.map(i => i.Photos);
			var photosCount = 0;
			if(photos[0]!=undefined){
				photosCount = photos[0].length;
			}
			report.showBarTrolleyUploadImage = photosCount > 0 || report.BarTrolleys.length == 0;
			report.showBarTrolleyInsertData = !photosCount > 0 || report.BarTrolleys.length == 0;
			report.disableBarTrolleysPhotoRemarks = !photosCount > 0
		}
		

        /**
         * Get flight ids with pending reports 
         * @memberof CabinReportLocalEditFactory
         * @return [long] List of flight ids 
         */
		function getFlightIdsWithPendingReports() {
			var cabinReportLocalEdits = getCabinReportsFromStorage();
			var flightIds = [];
			if (cabinReportLocalEdits != null)
			{
				var now = moment();
				//var now = moment('2016-06-14') //For debug;
				for (var i = 0; i < cabinReportLocalEdits.length; i++) {
					var flightDate = moment(cabinReportLocalEdits[i].FlightDate);
					if (cabinReportLocalEdits[i].Status !== 'stored' && now.diff(flightDate, 'days') < 5) {
						flightIds.push(cabinReportLocalEdits[i].FlightId);
					}
				}
			}
			return flightIds;
		}
		
		//check if all orders are updated
		function flightOrdersIsCompleted(FlightOrders){
			return !FlightOrders.Orders.some(order => order.Status == "Pending" || (order.Status == "Not Delivered" && !order.Reason));
		}

		return service;
	}

})();